/**
 * ROI-based row coloring. Five buckets ported verbatim from
 * `dashboard.html:2186-2194`:
 *
 *   null / undefined      → roi-grey
 *   roi < -50             → roi-hard-red    (#7f1d1d)
 *   -50 <= roi <= -1      → roi-light-red   (#4a2a2a)
 *   -1 <  roi <  1        → roi-grey        (#3a3a3a)
 *   1  <= roi <  50       → roi-light-green (#14532d)
 *   roi >= 50             → roi-hard-green  (#022c22)
 *
 * Boundary behaviour follows the legacy `<` strict comparisons exactly
 * so QA regressions on exact -50 / -1 / 1 / 50 rows don't shift.
 */

export type DashboardRoiClass =
  | "roi-grey"
  | "roi-hard-red"
  | "roi-light-red"
  | "roi-light-green"
  | "roi-hard-green"

export function getDashboardRoiRowClass(
  roi: number | null | undefined,
): DashboardRoiClass {
  if (roi === null || roi === undefined) return "roi-grey"
  const roiValue = Number(roi)
  if (!Number.isFinite(roiValue)) return "roi-grey"
  if (roiValue < -50) return "roi-hard-red"
  if (roiValue <= -1) return "roi-light-red"
  if (roiValue < 1) return "roi-grey"
  if (roiValue < 50) return "roi-light-green"
  return "roi-hard-green"
}

/**
 * Background color + pinned-cell tint for each ROI bucket. Matches
 * the CSS swatches in `shared.css` so the React port doesn't depend
 * on the legacy stylesheet being loaded.
 */
export const ROI_ROW_STYLES: Record<
  DashboardRoiClass,
  { row: string; pinned: string }
> = {
  "roi-grey": { row: "#3a3a3a", pinned: "#3a3a3a" },
  "roi-hard-red": { row: "#7f1d1d", pinned: "#7f1d1d" },
  "roi-light-red": { row: "#4a2a2a", pinned: "#4a2a2a" },
  "roi-light-green": { row: "#14532d", pinned: "#14532d" },
  "roi-hard-green": { row: "#022c22", pinned: "#022c22" },
}
